import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { BaseConfigProvider } from '../../providers/base-config/base-config';
import { Platform, App } from 'ionic-angular/index';

/**
 * Generated class for the LargeSoruceComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'large-soruce',
  templateUrl: 'large-soruce.html',
  // host:{'(document:touchstart)':'preventDefault($event)',
  //   '(document:touchmove)':'preventDefault($event)'
  // }
})
export class LargeSoruceComponent implements OnChanges {
  // text: string;

  @Input() sources;
  @Input() show_index: number;
  @Input() source_type;
  @Output() hideLarge = new EventEmitter();

  platform_width;
  platform_height;

  constructor(public _app: App, public platform: Platform) {
    platform.ready().then(() => {
      this.platform_width = platform.width();
      this.platform_height = platform.height();
    });

    // console.log('Hello LargeSoruceComponent Component');
    // this.text = 'Hello World';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['show_index'] && this.sources && this.source_type == 'video') {
      this.sources[this.show_index].pre_url = this.sources[this.show_index].url;
    }
  }

  onSwipe(e) {
    if (e.deltaX > 20 && this.show_index > 0) {
      this.show_index--;
    } else if (e.deltaX < -20 && this.show_index < this.sources.length - 1) {
      this.show_index++;
    }
  }
  hide() {
    this.hideLarge.emit('false');
  }
  get BaseUrl() {
    return BaseConfigProvider.SOURCE_BASE_PATH;
  }

  showThis(index, e) {
    e.stopPropagation();
    this.show_index = index;
  }

  // preventDefault(e){
  //   e.preventDefault();
  // }
}



// WEBPACK FOOTER //
// ./src/components/large-soruce/large-soruce.ts